import * as types from './types';
import { Dataset } from '@interfaces/outreach-entity';
import { YearsFilter } from '@interfaces/years-filter';
import { RequestState } from '@interfaces/request-state';
import { OutreachRequestParams } from '@interfaces/outreach-request-params';
import ListResponse from '@interfaces/list-response';

export interface DatasetsPageState extends RequestState {
    readonly list: ListResponse<Dataset>;
    readonly listParams: OutreachRequestParams;
    readonly filters: YearsFilter & RequestState;
}

const initialState: DatasetsPageState = {
    list: {
        rows: [],
        meta: {}
    },
    listParams: {},
    filters: {
        years: [],
        isLoading: false,
        error: undefined
    },
    isLoading: false,
    error: undefined
};

/* tslint:disable-next-line cyclomatic-complexity */
function reducer(state = initialState, action: any): DatasetsPageState {
    switch (action.type) {
        case types.FETCH_DATASETS_PAGE:
            return fetchDatasets(state, action);

        case types.FETCH_DATASETS_PAGE_SUCCESS:
            return fetchDatasetsSuccess(state, action);

        case types.FETCH_DATASETS_PAGE_ERROR:
            return fetchDatasetsError(state, action);

        case types.FETCH_DATASETS_FILTERS:
            return fetchDatasetsFilters(state);

        case types.FETCH_DATASETS_FILTERS_SUCCESS:
            return fetchDatasetsFiltersSuccess(state, action);

        case types.FETCH_DATASETS_FILTERS_ERROR:
            return fetchDatasetsFiltersError(state, action);

        default:
            return state;
    }
}

function fetchDatasets(state: DatasetsPageState, action: any) {
    const { page = 1 } = action.payload || {};

    const list = {
        ...state.list,
        rows: page === 1 ? [] : state.list.rows
    };

    return {
        ...state,
        list,
        isLoading: true,
        error: undefined
    };
}

function fetchDatasetsSuccess(state: DatasetsPageState, action: any) {
    const { data, params } = action.payload;
    const { meta, rows: actionRows } = data;
    const rows = meta.pageNumber === 1 ? actionRows : [...state.list.rows, ...actionRows];

    return {
        ...state,
        list: { meta, rows },
        listParams: params,
        isLoading: false,
        error: undefined
    };
}

function fetchDatasetsError(state: DatasetsPageState, action: any) {
    return {
        ...state,
        isLoading: false,
        error: action.payload
    };
}

function fetchDatasetsFilters(state: DatasetsPageState) {
    return {
        ...state,
        filters: {
            ...state.filters,
            isLoading: true,
            error: undefined
        }
    };
}

function fetchDatasetsFiltersSuccess(state: DatasetsPageState, action: any) {
    const { years } = action.payload;

    return {
        ...state,
        filters: {
            ...state.filters,
            isLoading: false,
            years
        }
    };
}

function fetchDatasetsFiltersError(state: DatasetsPageState, action: any) {
    return {
        ...state,
        filters: {
            ...state.filters,
            isLoading: false,
            error: action.payload
        }
    };
}

export default reducer;
